<style scoped>
#delivery-bar {
  left: 0;
  right: 0;
  background-color: white;
  border-bottom: 1px solid lightgray;
  z-index: 3;
  top: 'inherit';
}

.fixed #delivery-bar {
  left: 0;
  right: 0;
  z-index: 2;
}

#delivery-bar.fixed {
  top: 64px;
}

.btn-compound .input-field {
  padding: 0 16px;
}

.fullwidth {
  width: 100%;
}

.btn-compound.fullwidth {
  justify-content: flex-start;
}

.grow-enter-active {
  transition: width 0.3s ease;
}

.grow-enter {
  width: 0;
}
</style>

<template lang="pug">
div(v-if='isValidUser')
  #delivery-bar.navbar(:class='{ fixed: fixed === true }')
    .hide-on-small-only
      //- .btn-compound(:class='{fullwidth: editLocation}')
      //-   a.btn-compound-item.waves-effect(@click='toggleEditLocation')
      //-     i.material-icons place
      //-   a.btn-compound-item.waves-effect.truncate(@click='setEditLocation' v-if='!editLocation')
      //-     span(v-if='location') {{location}}
      //-     span(v-else) Set your location
      //-   transition(name='grow')
      //-     input-location-autocomplete.fullwidth(
      //-       v-if='editLocation'
      //-       compact='true'
      //-       :initialLocation='location'
      //-       @onAutocomplete='onLocationAutocomplete'
      //-       ref='locationAutocomplete'
      //-       @onCancelAutocomplete='cancelEditLocation')
      #cart.btn-compound.right(v-if='!editLocation')
        router-link.btn-compound-item.waves-effect(:to='"/cart"')
          i.material-icons shopping_cart
        router-link.btn-compound-item.waves-effect(:to='"/cart"') {{ cartQuantity }}

    .btn-compound.hide-on-med-and-up.right(v-if='!editLocation')
      router-link.btn-compound-item.waves-effect(:to='"/cart"')
        i.material-icons shopping_cart
      router-link.btn-compound-item.waves-effect(:to='"/cart"') {{ cartQuantity }}
    //-   a.btn-compound-item.waves-effect(@click='toggleEditLocation')
    //-     i.material-icons place
    //-   a.btn-compound-item.waves-effect.truncate(@click='setEditLocation' v-if='!editLocation') {{location}}
    //-   transition(name='grow')
    //-     input-location-autocomplete.fullwidth(
    //-       v-if='editLocation'
    //-       compact='true'
    //-       :initialLocation='location'
    //-       @onAutocomplete='onLocationAutocomplete'
    //-       ref='locationAutocomplete'
    //-       @onCancelAutocomplete='cancelEditLocation')
</template>
<script>
import InputLocationAutocomplete from '@/components/input-location-autocomplete'
import AlertModal from 'inomph-common/dist/components/alert-modal-content.js'

export default {
  props: ['fixed', 'top'],
  data() {
    return {
      editLocation: false,
      changeLocationTo: null,
    }
  },
  computed: {
    cartQuantity() {
      return Object.keys(this.$store.state.cart.items).length
    },
    address() {
      return this.$store.state.cart.address
        ? this.$store.state.cart.address.name
        : 'Set delivery address'
    },
    location() {
      return this.$store.state.cart.location
    },
    isValidUser() {
      let user = this.$store.state.auth.user
      if (user) {
        if (user.type === 'reseller') {
          if (user.status === 'disabled' || user.status === 'application') {
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      }
    },
  },
  methods: {
    toggleEditLocation() {
      if (this.editLocation) {
        this.cancelEditLocation()
      } else {
        this.setEditLocation()
      }
    },
    cancelEditLocation() {
      this.editLocation = false
      this.$store.dispatch('modal/close')
    },
    setEditLocation() {
      this.editLocation = true
      this.$nextTick(() => {
        this.$refs.locationAutocomplete.focus()
      })
    },
    confirmEditLocation() {
      this.editLocation = false
      this.$store.dispatch('cart/clearCart')
      this.$store.dispatch('cart/setLocation', this.changeLocationTo)
      this.$store.dispatch('modal/close')
    },
    closeModal() {
      this.$store.dispatch('modal/close')
    },
    onLocationAutocomplete(location) {
      this.changeLocationTo = location

      const modalParams = {
        content: AlertModal,
        bind: {
          title: 'Change location',
          message: 'This will clear your cart. Continue?',
          positiveButton: {
            message: 'Okay',
            onClick: this.confirmEditLocation.bind(this),
          },
          negativeButton: {
            message: 'Cancel',
            onClick: this.cancelEditLocation.bind(this),
          },
        },
      }

      this.$store.dispatch('modal/open', modalParams)
    },
  },
  components: {
    InputLocationAutocomplete,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/app-delivery-bar.vue